/**
 * 舰队态势。数字来自 /fleet/summary,按设备类别分组。
 * 「从未接入」单独列出来:那不是掉线,是注册了还没连上,处理方式完全不同。
 */
import type { HubSummary } from '@/lib/hubClient';
import { NA } from '@/lib/format';

const typeIcons: Record<string, string> = {
  dog: 'ri-android-line', glasses: 'ri-glasses-line', phone: 'ri-smartphone-line',
  drone: 'ri-flight-takeoff-line', vehicle: 'ri-car-line', other: 'ri-device-line',
};
const typeLabels: Record<string, string> = {
  dog: '机器狗', glasses: 'AI眼镜', phone: '手机', drone: '无人机', vehicle: '无人车', other: '其它',
};

export default function FleetStatusCard({ summary, loading }: { summary: HubSummary | null; loading: boolean }) {
  const d = summary?.devices;
  const kinds = Object.entries(d?.byKind ?? {});

  return (
    <div className="bg-background-50 border border-background-200/70 rounded-xl p-5 h-full">
      <h3 className="text-sm font-semibold text-foreground-800 font-heading mb-4">舰队态势</h3>

      <div className="flex items-end gap-2 mb-1">
        <span className="text-3xl font-bold font-mono text-foreground-900">
          {loading && !d ? '…' : d ? d.online : NA}
        </span>
        <span className="text-sm text-foreground-500">/ {d ? d.total : NA} 在线</span>
      </div>
      <div className="flex flex-wrap gap-x-3 gap-y-1 text-[11px] text-foreground-400 mb-4">
        {d && d.neverSeen > 0 && <span>{d.neverSeen} 台从未接入</span>}
        {d && d.revoked > 0 && <span>{d.revoked} 台已吊销</span>}
        {summary?.network?.configured === false && <span>私有网未配置</span>}
      </div>

      {kinds.length === 0 ? (
        <p className="text-xs text-foreground-400">
          {loading ? '读取中…' : '注册表里还没有设备。到「设备」页注册第一台。'}
        </p>
      ) : (
        <div className="space-y-3">
          {kinds.map(([kind, st]) => {
            const pct = st.total > 0 ? (st.online / st.total) * 100 : 0;
            return (
              <div key={kind} className="flex items-center gap-3">
                <span className="w-8 h-8 rounded-lg bg-background-100 flex items-center justify-center shrink-0">
                  <i className={`${typeIcons[kind] ?? typeIcons.other} text-base text-foreground-600`} />
                </span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between text-xs mb-1">
                    <span className="text-foreground-700">{typeLabels[kind] ?? kind}</span>
                    <span className="font-mono text-foreground-500">{st.online}/{st.total}</span>
                  </div>
                  <div className="h-1.5 rounded-full bg-background-200 overflow-hidden">
                    <div className="h-full rounded-full bg-accent-500 transition-all" style={{ width: `${pct}%` }} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
